const commonStore = {
	namespaced: true,
	state: {
		
	},
	getters: {

	},
	mutations: {

	},
	actions: {

	},


};

export default commonStore; 